define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SrCrTypeDomain = void 0;
    class SrCrTypeDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: SrCrTypeDomain.StatusCategoryChange, value: "Status/Category Change" },
                    { key: SrCrTypeDomain.AddSrnParcel, value: "Add SRN parcel" },
                    { key: SrCrTypeDomain.RemoveSrnParcel, value: "Remove SRN parcel" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[SrCrTypeDomain.StatusCategoryChange] = 0;
                this.KeyIndex[SrCrTypeDomain.AddSrnParcel] = 1;
                this.KeyIndex[SrCrTypeDomain.RemoveSrnParcel] = 2;
                this.ValueIndex = {};
                this.ValueIndex["Status/Category Change"] = 0;
                this.ValueIndex["Add SRN parcel"] = 1;
                this.ValueIndex["Remove SRN parcel"] = 2;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.SrCrTypeDomain = SrCrTypeDomain;
    Object.defineProperty(SrCrTypeDomain, "StatusCategoryChange", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(SrCrTypeDomain, "AddSrnParcel", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(SrCrTypeDomain, "RemoveSrnParcel", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(SrCrTypeDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
